/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiStringValues } from './ApiStringValues';
import {
  ApiStringValuesFromJSON,
  ApiStringValuesFromJSONTyped,
  ApiStringValuesToJSON,
  ApiStringValuesToJSONTyped,
} from './ApiStringValues';
import type { PredicateOp } from './PredicateOp';
import {
  PredicateOpFromJSON,
  PredicateOpFromJSONTyped,
  PredicateOpToJSON,
  PredicateOpToJSONTyped,
} from './PredicateOp';
import type { ApiLongValues } from './ApiLongValues';
import {
  ApiLongValuesFromJSON,
  ApiLongValuesFromJSONTyped,
  ApiLongValuesToJSON,
  ApiLongValuesToJSONTyped,
} from './ApiLongValues';
import type { ApiIntValues } from './ApiIntValues';
import {
  ApiIntValuesFromJSON,
  ApiIntValuesFromJSONTyped,
  ApiIntValuesToJSON,
  ApiIntValuesToJSONTyped,
} from './ApiIntValues';

/**
 * Predicate captures individual conditions that must be true for a resource
 * being filtered.
 * @export
 * @interface ApiPredicate
 */
export interface ApiPredicate {
  /**
   *
   * @type {PredicateOp}
   * @memberof ApiPredicate
   */
  op?: PredicateOp;
  /**
   *
   * @type {string}
   * @memberof ApiPredicate
   */
  key?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPredicate
   */
  int_value?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPredicate
   */
  long_value?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPredicate
   */
  string_value?: string;
  /**
   * Timestamp values will be converted to Unix time (seconds since the epoch)
   * prior to being used in a filtering operation.
   * @type {Date}
   * @memberof ApiPredicate
   */
  timestamp_value?: Date;
  /**
   *
   * @type {ApiIntValues}
   * @memberof ApiPredicate
   */
  int_values?: ApiIntValues;
  /**
   *
   * @type {ApiLongValues}
   * @memberof ApiPredicate
   */
  long_values?: ApiLongValues;
  /**
   *
   * @type {ApiStringValues}
   * @memberof ApiPredicate
   */
  string_values?: ApiStringValues;
}

/**
 * Check if a given object implements the ApiPredicate interface.
 */
export function instanceOfApiPredicate(value: object): value is ApiPredicate {
  return true;
}

export function ApiPredicateFromJSON(json: any): ApiPredicate {
  return ApiPredicateFromJSONTyped(json, false);
}

export function ApiPredicateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPredicate {
  if (json == null) {
    return json;
  }
  return {
    op: json['op'] == null ? undefined : PredicateOpFromJSON(json['op']),
    key: json['key'] == null ? undefined : json['key'],
    int_value: json['int_value'] == null ? undefined : json['int_value'],
    long_value: json['long_value'] == null ? undefined : json['long_value'],
    string_value: json['string_value'] == null ? undefined : json['string_value'],
    timestamp_value:
      json['timestamp_value'] == null ? undefined : new Date(json['timestamp_value']),
    int_values: json['int_values'] == null ? undefined : ApiIntValuesFromJSON(json['int_values']),
    long_values:
      json['long_values'] == null ? undefined : ApiLongValuesFromJSON(json['long_values']),
    string_values:
      json['string_values'] == null ? undefined : ApiStringValuesFromJSON(json['string_values']),
  };
}

export function ApiPredicateToJSON(json: any): ApiPredicate {
  return ApiPredicateToJSONTyped(json, false);
}

export function ApiPredicateToJSONTyped(
  value?: ApiPredicate | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    op: PredicateOpToJSON(value['op']),
    key: value['key'],
    int_value: value['int_value'],
    long_value: value['long_value'],
    string_value: value['string_value'],
    timestamp_value:
      value['timestamp_value'] == null
        ? value['timestamp_value']
        : value['timestamp_value'].toISOString(),
    int_values: ApiIntValuesToJSON(value['int_values']),
    long_values: ApiLongValuesToJSON(value['long_values']),
    string_values: ApiStringValuesToJSON(value['string_values']),
  };
}
